import { IPagination } from 'src/requests/BaseRequest';
import { ICommunity } from '../community';
import rf from 'src/requests/RequestFactory';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface IUser {
  user: { id: number };
  isActive: boolean;
  id: string;
  avatar?: string;
  email?: string;
  fullName?: string;
  displayName?: string;
  roles: string[];
  community?: ICommunity;
  status: string;
  gender?: string;
  age?: number;
  fitbitEncodeId?: string;
  garminUserId?: string;
  deviceVersion?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IUpdateUsersParams {
  userId: string;
  communityId: number;
}

export const getUsers = createAsyncThunk(
  'users/get-users',
  async (params: IPagination) => {
    try {
      const response = await rf
        .getRequest('MiraSleepUserRequest')
        .getUsers(params);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const updateUsers = createAsyncThunk(
  'users/update-users',
  async (body: IUpdateUsersParams[]) => {
    try {
      const response = await rf
        .getRequest('MiraSleepUserRequest')
        .updateUsers(body);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);
